<div class="card">
	<div *ngIf="subscriptionItemSelected" class="">
		<div class="p-grid">
			<div class="p-col-12 p-md-6 animation-slide-in-top">
				<app-customer-subscription-record [(subscriptionItem)]="subscriptionItemSelected"> </app-customer-subscription-record>
			</div>

			<div class="p-col-12 p-md-6 d-flex animation-slide-in-top">
				<p-divider layout="vertical"></p-divider>
				<app-customer-subscription-record-history
					[(subscriptionItem)]="subscriptionItemSelected"
					[(checkRecordSelected)]="checkRecordSelected"
				></app-customer-subscription-record-history>
			</div>
		</div>
	</div>

	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="customerService.customer?.value.subscriptions"
		[globalFilterFields]="app.keys(customerService.customer?.value.subscriptions)"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex flex-wrap">
				<span class="p-float-label p-input-icon-left m-2 flex-grow-1">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
				<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="onCreateNew()">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
							New Subscription
						</div>
					</ng-template>
				</p-button>
			</div>
		</ng-template>
		<ng-template pTemplate="header" #header>
			<tr>
				<th>Item</th>
				<th>Active</th>
				<th>Frequency</th>
				<th>Next Bill Date</th>
				<th>Occurances</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" #body let-rec let-idx="rowIndex">
			<tr (click)="onSubscriptionSelect(rec)">
				<td>
					<span class="p-column-title">Item</span>
					{{ rec.ooMenuItem.name }}
				</td>
				<td>
					<span class="p-column-title">Active</span>
					<fa-icon *ngIf="!rec.inactive" [icon]="['far', 'check']"></fa-icon>
				</td>
				<td class="">
					<span class="p-column-title">Frequency</span>
					<p-dropdown
						#idValue
						[options]="frequencyOptions"
						optionLabel="label"
						optionValue="value"
						name="frequencyOptionsList"
						[(ngModel)]="rec.frequency"
						[style]="{ width: '100%' }"
						appendTo="body"
						autoDisplayFirst="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						filterBy="filterByProperties"
						[disabled]="true"
					></p-dropdown>
				</td>
				<td>
					<span class="p-column-title">Next Bill Date</span>
					{{ moment.unix(rec.nextBillDate).format("l LT") }}
				</td>
				<td>
					<span class="p-column-title">Occurances</span>
					{{ rec.totalBilled }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-sidebar
	*ngIf="checkRecordSelected"
	[(visible)]="checkRecordSelected"
	position="right"
	appendTo="body"
	(onHide)="checkRecordSelected = undefined"
	[showCloseIcon]="false"
	styleClass="p-sidebar-md"
>
	<app-check-record-viewer [incomingCheck]="checkRecordSelected"></app-check-record-viewer>
</p-sidebar>
